module.exports = __webpack_public_path__ + "img/418651654681.e24dd648.jpg";